import { post } from "@/utils/request";

export default {
  // getList: query => post('/rrbi/column/getList', query),
  getPageList: query => post("/rrbi/commments/getPageList", query),
  update: query => post("/rrbi/commments/update", query),
  delete: id => post("/rrbi/commments/delComment/" + id)
};
